import React, { useState, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { AuthContext } from '../context/AuthProvider';
import { AppContext } from '../context/AppProvider';

export default function ProductActions({
  isEditing,
  cin7Id,
  shopifyB2cId,
  shopifyB2bId,
  handleDismiss,
  }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  if (!isEditing) return null;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
    handleCloseMenu();
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleConfirm = async () => {
    try {
      const res = await fetch("/api/products/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
        body: JSON.stringify({
          cin7Id: cin7Id,
          shopify: {
            b2c: shopifyB2cId,
            b2b: shopifyB2bId
          },
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(await res.text());
      }
  
      appContext.showMessage(
        data.message,
        data.severity || (data.success ? "success" : "warning")
      );
  
      setDialogOpen(false);
      handleDismiss();
    } catch (error) {
      appContext.showMessage(error.message);
    }
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleOpenDialog}>
          Deprecate and Delete this item
        </MenuItem>
      </Menu>
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Delete product
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to deprecate the item in Cin7 and remove the item in Shopify B2C and B2B if it exists. Do you wish to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Return
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            Deprecate and delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}